export const PlanRowAdditionalServices = () => (
  <div className="w-100 my-3 px-4">
    <div className="p-1 text-uppercase rounded rounded-2 bg-gray-200">
      <small>Additional Services</small>
    </div>
  </div>
);
